import { render, staticRenderFns } from "./reviewStudentView.vue?vue&type=template&id=499e46c7&scoped=true&"
import script from "./reviewStudentView.vue?vue&type=script&lang=js&"
export * from "./reviewStudentView.vue?vue&type=script&lang=js&"
import style0 from "./reviewStudentView.vue?vue&type=style&index=0&id=499e46c7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499e46c7",
  null
  
)

export default component.exports